// extracted by mini-css-extract-plugin
export default {"project_card":"ServiceCard_project_card__Xa1Gv","project_card_actions":"ServiceCard_project_card_actions__FfY8H"};